export default "__VITE_ASSET__BcPMdDMT__"